import { IconName } from '../components/Icon'
import { Dashboard } from '../models/Dashboard'

export const BANNER_DASHBOARDS = [
    // 'setup', // Quick Start, info
    'alerts_credential', // Resync calendar, danger
    // 'alerts_update_reader', // Update card reader, danger
    'alerts_renew', // Renew subscription, danger
    // 'setup_tcr', // NEEDS TO BE PORTED
    'alerts_nps',
    'verifications', // start getting paid, warning
    'alerts_tax_form', // Request your 1099-K today
]

export const MESSAGE_DASHBOARDS = [
    'alerts_asap',
    // 'alerts_refer', ??
    // 'alerts_affiliate', // https://pocketsuite.atlassian.net/browse/ENG-30440 disabling until bug is fixed
    'alerts_reader',
    'alerts_team',
    // 'alerts_review', ??
]

export const OPERATIONAL_DASHBOARDS = [
    'income',
    'complete',
    'invoices',
    'bookings',
    'packages',
    'employees',
    'subscriptions',
    'pending',
    'clients',
    'links',
    'deposits',
    'records',
    'classes',
    'reservations',
    'contracts',
    'estimates',
    'triggers',
    'orders',
    'inventory',
    'items',
    'tasks',
    'expenses',
    'cancellations',
    'billings',
    'gifts',
    'messages',
    'rebooks',
]

export const filterDashboardItems = (
    dashboards: Dashboard[],
    sortOrder?: string[],
    exclude: boolean = false
) => {
    sortOrder = sortOrder || OPERATIONAL_DASHBOARDS

    if (exclude) {
        return dashboards
            .filter((a) => a.id && sortOrder!.indexOf(a.id) === -1)
            .sort((a, b): number => {
                const aIndex = a.id && sortOrder!.indexOf(a.id)
                const bIndex = b.id && sortOrder!.indexOf(b.id)
                return (aIndex || 0) - (bIndex || 0)
            })
    }

    return dashboards
        .filter((a) => a.id && sortOrder!.indexOf(a.id) > -1)
        .sort((a, b): number => {
            const aIndex = a.id && sortOrder!.indexOf(a.id)
            const bIndex = b.id && sortOrder!.indexOf(b.id)
            return (aIndex || 0) - (bIndex || 0)
        })
}

export const getDashboardIcon = (dashboardID?: string): IconName => {
    switch (dashboardID) {
        case 'income':
            return 'dollar7'
        case 'complete':
            return 'bell'
        case 'bookings':
            return 'calendar'
        case 'packages':
            return 'package2'
        case 'employees':
            return 'employeeCard'
        case 'subscriptions':
            return 'repeat'
        case 'pending':
            return 'calendar2'
        case 'clients':
            return 'user3'
        case 'suite':
            return 'calendar'
        case 'deposits':
            return 'dollar3'
        case 'records':
            return 'field'
        case 'classes':
            return 'calendar'
        case 'contracts':
            return 'pen'
        case 'estimates':
            return 'dollar2'
        case 'triggers':
            return 'megaphone'
        case 'inventory':
            return 'box'
        case 'items':
            return 'shoppingCart'
        case 'tasks':
            return 'notepadCheckmark'
        case 'expenses':
            return 'wallet'
        case 'cancellations':
            return 'calendarMinus'
        case 'links':
            return 'computerCheckmark'
        case 'billings':
            return 'documentClock'
        case 'gifts':
            return 'gift'
        case 'schedule':
            return 'calendarAlarmClock'
        case 'rebooks':
            return 'calendarRefresh'
        case 'invoices':
            return 'dollar2'
        case 'orders':
            return 'truck'
        case 'messages':
            return 'envelopeClock'
        case 'reservations':
            return 'calendars'
        default:
            return 'exclamation'
    }
}

export const getViewTitleFromView = (dashboard?: Dashboard, view?: number) => {
    return dashboard?.viewOptions.find((o) => o.value === view?.toString())?.label ?? 'All'
}
